import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../../../services/index';
import { Progress,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import {  LineOutlined,DoubleRightOutlined,DoubleLeftOutlined} from '@ant-design/icons';

import $ from 'jquery';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function yearDiff(dt1, dt2) 
 {
 
  var diffYear =(dt2.getTime() - dt1.getTime()) / 1000;
   diffYear /= (60 * 60 * 24);
  return Math.abs(Math.round(diffYear/365.25));
   
 }

 var stock_data = [];

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			academic_year: 'all',
			category: '',
			type: '',
			sequence: '',
			details: '',
			class_list: [],
			student_list: [],
			array_id: [],
			manage_package_details: [],
			program_id: [],
			package_list: [],
			checked: false,
			checkedBoxes: [],
			selectedFiles:null,
			
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		
		this.change_year = this.change_year.bind(this);	
		this.change_type = this.change_type.bind(this);	
		this.change_package = this.change_package.bind(this);	
		this.change_class = this.change_class.bind(this);	
		
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onChanstudentpackage = this.onChanstudentpackage.bind(this);
		
		
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],program_id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'] });
		}
		
		this.checkData();
	}	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {school_id : school_id,user_id:user_id}
			getData('fees/class_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							class_list: result['data'],
						});
					}else{
						this.setState({
							class_list: [],
						});
					}
				}
			});	
			var app_2 = {school_id : school_id,user_id:user_id,academic_year:this.state.academic_year,type : this.props.match.params.text,}
			getData('fees/package',app_2).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							package_list: result['data'],
						});
					}else{
						this.setState({
							package_list: [],
						});
					}
				}
			});	
				
			
	}
  }
	
	change_year(event){
         this.setState({academic_year: event});
		 document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
    	setTimeout(() => {
			this.checkData();
		}, 20);
     }
	 
	change_type(event){
         this.setState({type: event});
		 document.getElementsByClassName('ant-select-selection')[1].classList.remove("error_focus");
     }
	 
	change_class(event){
         this.setState({class_id: event});
		 var app = {class_id : event,user_id:this.state.user_id}
			getData('fees/student_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							student_list: result['data'],
							array_id: result['id'],
						});
					}else{
						this.setState({
							student_list: [],
							array_id : []
						});
					}
				}
			});	
		 
     }
	 
	change_package(event){
         this.setState({package: event});
		 var app = {id : event,user_id:this.state.user_id}
			getData('fees/package_item_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							manage_package_details: result['data'],
						});
					}else{
						this.setState({
							manage_package_details: [],
						});
					}
				}
			});	
		 
     }

	 onChanstudentpackage(id,event){
         document.getElementById('student_package_id_'+id).value = event;
     }
	 
	
	
	handleSizeChange = e => {		
		this.setState({ [e.target.name]: e.target.value });		
		if(e.target.name){
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
		}
	 };
	  
	
	  
	  handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });

		if(this.state.type == 'Student'){
		let war_arr=this.state.array_id;
		var stop = [];
		  war_arr.forEach(function (id, index) {	
			

			var student_package_id = document.getElementById('student_package_id_'+id).value
			var student = document.getElementById('student_'+id).value
			 	
			var arr ={
				id: id,
				student_package_id: student_package_id,
				student: student,
			}
			
			stock_data.forEach((list, index) => {	
			 if(list['id'] == arr['id']){	
				stock_data.splice(index, 1);	 
			 }	
			});
			stock_data.push(arr);
			
			
		 });
		
		}
		var app = {
			
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			academic_year : this.state.academic_year,
			assign_to : this.state.type,
			class : this.state.checkedBoxes,
			package_id : this.state.package,
			stock_data : stock_data,
			student_class_id : this.state.class_id,
			type : this.props.match.params.text
		}
		
		getData('fees/add_assign_package',app).then((result) => {
			if(result.status==400){
				message.config({ top: 150});
				message.error(result.error_msg,2);
				if(result.error_name==''){
					document.getElementsByClassName('ant-select-selection')[result.error_key].classList.add("error_focus");
				}
				else{					
					if(result.error_name!=''){
						document.getElementsByName(result.error_name)[0].classList.add("error_focus");
					}					
				}
				this.setState({ loading: false });
			}
			else if(result.status==200){
				message.config({ top: 150});
				message.success('Assign Fees Package Successfully !!',2);
				this.setState({ loading: false });
				this.setState({comment_text:''});
				window.location.href = '/settings/fees/assign_fees_package';
			}
			else{
				this.setState({ loading: false });
			}
		});
	  }else{
		message.error('Please Login',2);	
		this.setState({ loading: false });
	  }

	}
  
    toggleChecked = () => {
		
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true,selection_count:checkedBoxes.length,selected_student:checkedBoxes,children_id:checkedBoxes});
		console.log(checkedBoxes);
    }
	
	toggleUnChecked = () => {
		
		const checkedBoxes = [...this.state.checkedBoxes];
		this.setState({checkedBoxes:[],checked:false,selection_count:0,selected_student:[],children_id:[]});
    }
  
  handleCheckbox = (e, s) => {
	
    const checkedBoxes = [...this.state.checkedBoxes];
    if(e.target.checked) {
		checkedBoxes.push(s)
    } else {
		const index = checkedBoxes.findIndex((ch) => ch === s);
		checkedBoxes.splice(index, 1);
    }
    this.setState({checkedBoxes,selection_count:checkedBoxes.length,selected_student:checkedBoxes,children_id:checkedBoxes});
  }
  
  

	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     
					
		return (
			<div class="mobile_view setting">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 
		
		<div class="col col-md-12  ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					  <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Add Assign Fees Package</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   
						   <li class="breadcrumb-item"><a href="/settings/fees">Fees Setting</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/settings/fees/assign_fees_package">Assign Fees Package</a>
                           </li>
						   <li class="breadcrumb-item active">Add 
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
            <div class="col col-md-12  ex-padd add" >
			
			
			
			<div class="container view-Profile child-profile">
			   <div class="col col-md-12  mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food mh-500">
					<div class="children mb-20  iq-card2 flow-root ">
                     
						<div class="d-flex">
						  
						  <div class="col col-md-12 s12 no-padd">
						  
							<div class="col m12 s12 no-padd">
								<div class="col m4 s12 mb-10 pb-20">
										<label>Academic Year</label>
										<Select onChange={this.change_year}>
										 <Select.Option value="2022-2023">2022-2023</Select.Option>	
										 <Select.Option value="2021-2022">2021-2022</Select.Option>	
										 <Select.Option value="2020-2021">2020-2021</Select.Option>
										 <Select.Option value="2019-2020">2019-2020</Select.Option>
										 <Select.Option value="2018-2019">2018-2019</Select.Option>
										</Select>
								</div>	
								<div class="col m4 s12 mb-10 ">
										<label>Assign To</label>
										<Select onChange={this.change_type}>
												<Select.Option value="Class">Class</Select.Option>
												<Select.Option value="Student">Student Specific</Select.Option>
										</Select>
								</div>
							</div>	
							{(() => {
								if (this.state.type=='Class') {
									return (
										<>
										<div class="col m12 s12">
											<div class="col m12 s12 no-padd">
												
													{(() => {
														if (this.state.checked==true) {
															return (
																<>
																<Checkbox  
																	onClick={this.toggleUnChecked.bind(this)}
																	checked="checked"
																	id="all"
																>
																<label for="all" className="select-all">UNSELECT All </label>
																</Checkbox>
																</>
															)
														}
														else{
															return (
																<>
																<Checkbox  
																	onClick={this.toggleChecked.bind(this)}
																	checked=""
																	id="all"
																>
																<label for="all" className="select-all">SELECT All </label>
																</Checkbox>
																</>
															)
														}
													})()}
												</div>
												{this.state.class_list.map((list) => (
													<div class="col m3 s6 d-contents mob-d-block">
													   <Checkbox  
														name="checked_id[]"
														value={list.id}
														id={list.id}
														checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
														onChange={(e) => this.handleCheckbox(e, list.id)}
														>
														<label for={list.id} className="checked">
														   <div class="center">{list.name}</div>
														</label>
													   </Checkbox>
												   </div>
												))}   
											
										</div>
										<div class="col m4 s12 mb-10 mt-20">
												<label>Package</label>
												<Select onChange={this.change_package} defaultValue="Select Package">
													<Select.Option value=''>Select Package</Select.Option>
													{this.state.package_list.map((list) => (
														<Select.Option value={list.id}>{list.name}</Select.Option>
													))}
												</Select>
										</div>
										<div class="col m12 s12 mb-10 mt-20">
											<table class="cust_table">
											  <thead>
												<tr>
													<th class="">Sr. No</th>
													<th class="">Category</th>
													<th>Amount</th>
													<th>Due Date</th>
													<th>Due Charges</th>
													
												</tr>
											  </thead>

												<tbody>
												{this.state.manage_package_details.map((list) => (
													<tr>
														<td>{list.sr_no}</td>
														<td>{list.category}</td>
														<td>{list.amount}</td>
														<td>{list.date}</td>
														<td>{list.daily_charges}</td>
														
													</tr> 
												))}		
															
															
												</tbody>
											</table>
										</div>
										</>
										)
								}
							})()}
							{(() => {
								if (this.state.type=='Student') {
									return (
										<>
										<div class="col m4 s12 mb-10 mt-10">
												<label>Select Class</label>
												
												<Select onChange={this.change_class}>
												{this.state.class_list.map((list) => (
														<Select.Option value={list.id}>{list.name}</Select.Option>
												))}		
												</Select>
												
										</div>
										<div class="col m12 s12 mb-10 mt-20">
											<table class="cust_table">
											  <thead>
												<tr>
													<th class="">User Id</th>
													<th class="">Student Name</th>
													<th>Package</th>
												</tr>
											  </thead>

												<tbody>
												{this.state.student_list.map((list) => (
													<tr>
														<td>
														{list.id}
														<input type="hidden" id={`student_${list.id}`} value={list.id} />	
														</td>
														<td>{list.name}</td>
														<td class="w-300px">
															<Select  defaultValue="Select Package" onChange={this.onChanstudentpackage.bind(this,list.id)}>
																<Select.Option value=''>Select Package</Select.Option>
																{this.state.package_list.map((list) => (
																	<Select.Option value={list.id} >{list.name}</Select.Option>
																))}
															</Select>
															<input type="hidden"  id={`student_package_id_${list.id}`}  />
														</td>
														
														
													</tr> 
												))}	

												{(() => {
												if (this.state.student_list.lenght =='0') {
													return (	
															<td colspan="3">No Student Found</td>
															)
														}
												})()}
															
												</tbody>
											</table>
										</div>
										</>
										)
								}
							})()}
								
								
																
						  </div>
						</div>
							
						
					</div> 
					
					
					<div class="col col-md-12 s12 meal bt pt-10 mb-10 center">
						 <Button className="snd-btn" onClick={this.handleSubmit} loading={this.state.loading}>Assign</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
